module.exports = __webpack_public_path__ + "static/partner-346c54151f95847c9b9a819ff905148b.png";